export const branchImages = {
  Masgouf: "/Images/branchesLogo/maskof.png",
  Melenzane: "/Images/branchesLogo/melenzane.png",
  Trapani: "/Images/branchesLogo/trapani.png",
  Grove: "/Images/branchesLogo/grove.png",
  Okra: "/Images/branchesLogo/okra.png",
  Cafad: "/Images/branchesLogo/kaftria.png",
  "Meat at Tony s": "/Images/branchesLogo/meat-at-tonys.png",
};

export const tabs = [
  {
    label: "House",
    activeImgSrc: "/Images/addressForm/house-white.png",
    inactiveImgSrc: "/Images/addressForm/house-black.png",
  },
  {
    label: "Apartment",
    activeImgSrc: "/Images/addressForm/apartment-white.png",
    inactiveImgSrc: "/Images/addressForm/apartment-black.png",
  },
  {
    label: "Office",
    activeImgSrc: "/Images/addressForm/office-white.png",
    inactiveImgSrc: "/Images/addressForm/office-black.png",
  },
];
